import React from 'react';
import { useTranslation } from 'react-i18next';
import { postEvent } from 'src/api/postEvent';

import {
  getImprintLink,
  getLegalLink,
  getPrivacyLink,
  links
} from '../../constants/constants';
import { useStateValue } from '../../hooks/useState';
import { useWideScreen } from '../../hooks/useWide';
import { Ellipse } from './Ellipse';
import styles from './Footer.module.css';

interface Props {
  isIFrame?: boolean;
}

interface Link {
  text: string;
  href: string;
  onClick?: any;
  isMobile: boolean;
}

const Link = ({ text, href, isMobile, onClick }: Link) => (
  <a
    className={isMobile ? styles.aMobile : ''}
    target="_blank"
    rel="noopener noreferrer"
    onClick={onClick}
    href={href}
  >
    {text}
  </a>
);

export const Footer = (props: Props) => {
  const { t } = useTranslation();

  const [{ uuid = '' }, dispatch] = useStateValue();

  const isWideScreen = useWideScreen();

  if (!isWideScreen) {
    return null;
  }

  return (
    <footer className={styles.footerWrapper}>
      <div className={styles.footerBlock}>
        <Link
          isMobile={!isWideScreen}
          text={t('Imprint')}
          href={getImprintLink()}
          onClick={() => {
            postEvent({
              uuid,
              event: isWideScreen
                ? 'WEB.JUMP.ACTION.FOOTER.IMPRINT'
                : 'WEB.JUMP.ACTION.MOBILE.MENU.IMPRINT',
              details: {}
            });
          }}
        />

        <Ellipse />

        <Link
          isMobile={!isWideScreen}
          text={t('Data Privacy')}
          href={getPrivacyLink()}
          onClick={() => {
            postEvent({
              uuid,
              event: isWideScreen
                ? 'WEB.JUMP.ACTION.FOOTER.DATA_PRIVACY'
                : 'WEB.JUMP.ACTION.MOBILE.MENU.DATA_PRIVACY',
              details: {}
            });
          }}
        />

        <Ellipse />

        <Link
          isMobile={!isWideScreen}
          text={t('Legal Information')}
          href={getLegalLink()}
          onClick={() => {
            postEvent({
              uuid,
              event: isWideScreen
                ? 'WEB.JUMP.ACTION.FOOTER.LEGAL_INFO'
                : 'WEB.JUMP.ACTION.MOBILE.MENU.LEGAL_INFO',
              details: {}
            });
          }}
        />
      </div>

      {!props.isIFrame && (
        <div>
          Copyright © {new Date().getFullYear()} Nect GmbH.{' '}
          {t('All Rights Reserved.')}
        </div>
      )}

      <div className={styles.footerBlock}>
        <Link
          isMobile={!isWideScreen}
          text={t('Contact')}
          href={links.contact}
          onClick={() => {
            postEvent({
              uuid,
              event: 'WEB.JUMP.ACTION.MOBILE.MENU.CONTACT',
              details: {}
            });
          }}
        />
      </div>
    </footer>
  );
};
